import { useState, useEffect, useCallback } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import vector from "../assets/images/star-img.svg";
import linkImg from "../assets/images/link-img.svg";
import Modal from "react-bootstrap/Modal";
import { postData } from "../../axios/apiHelper";
import { ENDPOINT } from "../../axios/apiConfig";
import { loader } from "../../loader";
import Form from "react-bootstrap/Form";
import TopicModals from "./Topics";
import { toast } from "react-toastify";
import ContentEditor from "./Editor";
import Select from "react-select";
import * as Yup from "yup";
import Popup from "../VWD/Common/Modal/ModalWrapper";
import CommonModals from "../VWD/Common/Modal/CommonModals";

let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
function LinkWithTooltip({ id, children, href, tooltip }) {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip id={id}>
          <div dangerouslySetInnerHTML={{ __html: tooltip }} />
        </Tooltip>
      }
      placement="top"
      delayShow={300}
      delayHide={150}
    >
      <a href={href}>{children}</a>
    </OverlayTrigger>
  );
}

const validationSchema = Yup.object().shape({
  narrativeTitle: Yup.string()
    .transform((val) => (val == null ? "" : String(val)))
    .trim()
    .required("Narrative Title is required"),

  narrativeContent: Yup.string()
    .transform((val) => (val == null ? "" : String(val)))
    .trim()
    .required("Narrative Content is required"),

  contributionTitle: Yup.string()
    .transform((val) => (val == null ? "" : String(val)))
    .trim()
    .required("Contribution Title is required"),

  contributionContent: Yup.string()
    .transform((val) => (val == null ? "" : String(val)))
    .trim()
    .required("Contribution Content is required"),

  finalTags: Yup.array()
    .of(Yup.string())
    .min(1, "At least one topic is required"),
});

export const ModalContent = ({
  currentOpenedNarrative,
  allTags,
  setAllTags,
  narratives,
  ageGroups,
  setShow,
  categories,
  handleClose,
  fetchAllData,
}) => {
  const [currentDiagnosis, setCurrentDiagnosis] = useState({});
  const [showCurrent, setShowCurrent] = useState(true);
  const [ageGroup, setAgeGroup] = useState({});
  const [isMaster, setIsMaster] = useState(true);
  const [allMaster, setAllMaster] = useState([]);
  const [selectedMasterId, setSelectedMasterId] = useState(null);
  const [showTopics, setShowTopics] = useState(false);
  const [isAllEmpty, setIsAllEmpty] = useState(true);
  const [draftSelected, setDraftSelected] = useState(false);
  const [currentCategoryType, setCurrentCategoryType] = useState("");
  const [popArguments, setPopArguments] = useState({
    show: false,
    headerText: null,
    onClose: () => {},
    headerIcon: "alert.png",
    bodyText: " ",
    buttons: [],
    headerClass: "",
    bodyClass: "",
  });
  const [isPublishDisabled, setIsPublishDisabled] = useState(true);
  const [formData, setFormData] = useState({
    narrativeTitle: "",
    narrativeContent: "",
    contributionTitle: "",
    contributionContent: "",
    finalTags: [],
  });
  const [isGotoMasterClicked, setIsGotoMasterClicked] = useState(false);
  const [currentGotoMasterLabel, setCurrentGotoMasterLabel] = useState("");

  useEffect(() => {
    if (!isMaster) {
      setIsGotoMasterClicked(false);
      setCurrentGotoMasterLabel("");
    }
  }, [isMaster]);

  useEffect(() => {
    validationSchema
      .isValid(formData)
      .then((valid) => setIsPublishDisabled(!valid));
    checkIsAllEmpty();
  }, [formData]);

  // useEffect(() => {
  //   if (currentOpenedNarrative) {
  //     setCurrentDiagnosis(
  //       categories.find((c) => c.id == currentOpenedNarrative.category_id)
  //     );
  //     setAgeGroup(
  //       ageGroups.find((a) => a.id == currentOpenedNarrative.age_group_id)
  //     );
  //     setIsMaster(currentOpenedNarrative.type == 1);
  //     setAllMaster(
  //       narratives.filter(
  //         (n) =>
  //           n.type == 1 &&
  //           (n.status == "Live" || n.status == "Draft") &&
  //           n.id != currentOpenedNarrative.id
  //       )
  //     );
  //     setSelectedMasterId(
  //       currentOpenedNarrative.type == 1
  //         ? null
  //         : currentOpenedNarrative.master_cell_id
  //     );
  //     setDraftSelected(currentOpenedNarrative.status == "Draft" ? true : false);
  //     setCurrentCategoryType(
  //       currentOpenedNarrative.type == 1 ? "master" : "linked"
  //     );
  //     // populate form when in master mode
  //     setFormData({
  //       narrativeTitle: currentOpenedNarrative.narrative_title || "",
  //       narrativeContent: currentOpenedNarrative.narrative_description || "",
  //       contributionTitle: currentOpenedNarrative.contibution_title || "",
  //       contributionContent:
  //         currentOpenedNarrative.contibution_description || "",
  //       finalTags: currentOpenedNarrative.tags || [],
  //     });
  //   }
  // }, [currentOpenedNarrative]);

  useEffect(() => {
    if (currentOpenedNarrative) {
      setCurrentDiagnosis(
        categories.find((c) => c.id == currentOpenedNarrative.category_id),
      );
      setAgeGroup(
        ageGroups.find((a) => a.id == currentOpenedNarrative.age_group_id),
      );
      setIsMaster(currentOpenedNarrative.type == 1);

      const filteredMasters = narratives.filter(
        (n) =>
          n.type == 1 &&
          (n.status == "Live" || n.status == "Draft") &&
          n.id != currentOpenedNarrative.id,
      );
      setAllMaster(filteredMasters);

      const linkedMasterId =
        currentOpenedNarrative.type == 1
          ? null
          : currentOpenedNarrative.master_cell_id;

      setSelectedMasterId(linkedMasterId);

      //  Check linked master’s status when component loads
      if (linkedMasterId) {
        const master = filteredMasters.find((m) => m.id === linkedMasterId);
        setDraftSelected(master?.status === "Draft");
      } else {
        setDraftSelected(currentOpenedNarrative.status === "Draft");
      }

      setCurrentCategoryType(
        currentOpenedNarrative.type == 1 ? "master" : "linked",
      );

      setFormData({
        narrativeTitle: currentOpenedNarrative.narrative_title || "",
        narrativeContent: currentOpenedNarrative.narrative_description || "",
        contributionTitle: currentOpenedNarrative.contibution_title || "",
        contributionContent:
          currentOpenedNarrative.contibution_description || "",
        finalTags: currentOpenedNarrative.tags || [],
      });
    }
  }, [currentOpenedNarrative, narratives]);

  const toggle = () => {
    setIsMaster(!isMaster);
    if (isMaster) {
      if (selectedMasterId != null) {
        const master = allMaster.find((m) => m.id === selectedMasterId);
        setFormData({
          narrativeTitle: master.narrative_title || "",
          narrativeContent: master.narrative_description || "",
          contributionTitle: master.contibution_title || "",
          contributionContent: master.contibution_description || "",
          finalTags: master.tags || [],
        });
      } else {
        setFormData({
          narrativeTitle: "",
          narrativeContent: "",
          contributionTitle: "",
          contributionContent: "",
          finalTags: [],
        });
      }
    } else {
      setFormData({
        narrativeTitle: currentOpenedNarrative?.narrative_title || "",
        narrativeContent: currentOpenedNarrative?.narrative_description || "",
        contributionTitle: currentOpenedNarrative?.contibution_title || "",
        contributionContent:
          currentOpenedNarrative?.contibution_description || "",
        finalTags: currentOpenedNarrative.tags || [],
      });
    }
  };

  const checkLinkedMasterStatus = (masterId) => {
    const master = allMaster.find((m) => m.id === masterId);
    if (master) {
      setDraftSelected(master.status === "Draft");
    } else {
      setDraftSelected(false);
    }
  };

  const handleMasterChange = (e) => {
    const masterId = parseInt(e.target.value, 10);
    setSelectedMasterId(masterId);
    checkLinkedMasterStatus(masterId); //  handle draft/live status

    const master = allMaster.find((m) => m.id === masterId);
    if (master) {
      setFormData({
        narrativeTitle: master.narrative_title || "",
        narrativeContent: master.narrative_description || "",
        contributionTitle: master.contibution_title || "",
        contributionContent: master.contibution_description || "",
        finalTags: master.tags || [],
      });
    }
  };

  // const handleMasterChange = (e) => {
  //   const masterId = parseInt(e.target.value, 10);
  //   setSelectedMasterId(masterId);
  //   const master = allMaster.find((m) => m.id === masterId);
  //   if (master) {
  //     if (master.status == "Draft") {
  //       setDraftSelected(true);
  //     } else {
  //       setDraftSelected(false);
  //     }
  //     setFormData({
  //       narrativeTitle: master.narrative_title || "",
  //       narrativeContent: master.narrative_description || "",
  //       contributionTitle: master.contibution_title || "",
  //       contributionContent: master.contibution_description || "",
  //       finalTags: master.tags || [],
  //     });
  //   }
  // };

  const handlePopupClose = useCallback(() => {
    setPopArguments((prev) => ({ ...prev, show: false }));
  }, []);

  const showPreviousPopup = () => {
    setShowCurrent(true);
    handlePopupClose();
  };

  const gotToLandingPage = () => {
    setShow(false);
    resetForm();
    fetchAllData();
  };

  const openConfirmationPopup = (status, type) => {
    setShowCurrent(false);

    const messages = {
      master: `<strong>Are you sure you want to change this Linked copy to a Master type?</strong> 
                  <p>This action will delete all existing content in the Linked copy. If you want to keep the text, please copy it before switching.</p>`,
      linked: `<strong>Are you sure you want to change this Master copy to a Linked type?</strong> 
                  <p>Doing so will permanently delete all written content in the Master.</p>`,
    };

    if (type != currentCategoryType) {
      handlePopArguments(
        true,
        showPreviousPopup,
        "alert.png",
        "",
        "",
        "",
        <div dangerouslySetInnerHTML={{ __html: messages[type] }} />,
        [
          {
            text: "Yes Please!",
            click: () => {
              handlePopupClose(); // close confirmation popup
              storeNarrativeCardData(status); // then proceed
            },
            className: "btn-filled",
          },
          {
            text: "Cancel",
            click: () => showPreviousPopup(),
            className: "btn btn-primary btn-bordered cancel-btn",
          },
        ],
      );
    } else {
      storeNarrativeCardData(status); // then proceed
    }
  };

  const checkIsAllEmpty = () => {
    const isEmpty =
      !String(formData.narrativeTitle || "").trim() &&
      !String(formData.narrativeContent || "").trim() &&
      !String(formData.contributionTitle || "").trim() &&
      !String(formData.contributionContent || "").trim() &&
      formData.finalTags.length === 0;

    setIsAllEmpty(isEmpty);
  };

  const handlePopArguments = (
    show = true,
    handleClose,
    headerIcon,
    headerText,
    headerClass,
    bodyClass,
    bodyText,
    buttons,
  ) => {
    const data = {
      show,
      onClose: () => handleClose(),
      headerIcon,
      headerText,
      headerClass,
      bodyClass,
      bodyText,
      buttons,
    };
    setPopArguments(data);
  };

  const PopHandler = ({ popArguments }) => {
    const {
      show,
      onClose,
      headerIcon,
      bodyText,
      headerText,
      headerClass,
      bodyClass,
      buttons,
    } = popArguments;

    return (
      <Popup
        show={show}
        onClose={onClose}
        headerIcon={headerIcon}
        headerClass={headerClass}
        headerText={headerText}
      >
        <CommonModals
          bodyText={bodyText}
          bodyClass={bodyClass}
          Buttons={buttons}
        />
      </Popup>
    );
  };

  const storeNarrativeCardData = async (status) => {
    try {
      loader("show");
      if (!isMaster && !selectedMasterId) {
        return toast.warning("Please select a master narrative to link to.");
      }
      const payload = {
        id: currentOpenedNarrative?.id,
        status,
        narrative_title: formData.narrativeTitle,
        narrative_description: formData.narrativeContent,
        contibution_title: formData.contributionTitle,
        contibution_description: formData.contributionContent,
        tags: formData.finalTags,
        type: isMaster ? 1 : 2,
        master_cell_id: isMaster ? null : selectedMasterId,
      };

      const res = await postData(ENDPOINT.STORENARRATIVE, { ...payload });

      handlePopupClose();

      handlePopArguments(
        true,
        gotToLandingPage,
        "success.png",
        "",
        "",
        "",
        <div
          dangerouslySetInnerHTML={{
            __html: `The Narrative has been ${
              status == "Live" ? "published" : "saved as draft"
            }<br/>successfully!`,
          }}
        />,
        [
          {
            text: "Close",
            click: () => gotToLandingPage(),
            className: "btn-bordered closed",
          },
        ],
      );
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      loader("hide");
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => {
      if (field === "finalTags") {
        return { ...prev, [field]: Array.isArray(value) ? value : [] };
      }
      return { ...prev, [field]: value == null ? "" : String(value) };
    });
  };
  const handleEditMaster = () => {
    if (selectedMasterId) {
      const master = allMaster.find((m) => m.id === selectedMasterId);
      if (master) {
        setIsMaster(true);
        setIsGotoMasterClicked(true);
        const diag = categories.find((c) => c.id === master.category_id);
        const age = ageGroups.find((a) => a.id === master.age_group_id);
        const ageLabel =
          age?.min_age == null && age?.max_age == null
            ? ""
            : age?.min_age == 0
              ? `| Age <${age?.max_age}`
              : age?.min_age == 26
                ? `| Age >${age?.min_age}`
                : ` | Age ${age?.min_age}${
                    age?.max_age ? ` - ${age?.max_age}` : "+"
                  }`;
        setCurrentGotoMasterLabel(`${diag?.name} ${ageLabel}`);
        setFormData({
          narrativeTitle: master.narrative_title || "",
          narrativeContent: master.narrative_description || "",
          contributionTitle: master.contibution_title || "",
          contributionContent: master.contibution_description || "",
          finalTags: master.tags || [],
        });
      }
    }
  };

  const removeTag = (index) => {
    setFormData((prev) => {
      const updated = prev.finalTags.filter((_, i) => i !== index);
      return { ...prev, finalTags: updated };
    });
  };

  const resetForm = () => {
    setShowCurrent(false);
    setFormData({
      narrativeTitle: "",
      narrativeContent: "",
      contributionTitle: "",
      contributionContent: "",
      finalTags: [],
    });
    setShow(false);
    setIsAllEmpty(true);
    setIsPublishDisabled(true);
    setSelectedMasterId(null);
    setShowTopics(false);
    setDraftSelected(false);
    setCurrentCategoryType("");
    setPopArguments({
      show: false,
      headerText: null,
      onClose: () => {},
      headerIcon: "alert.png",
      bodyText: " ",
      buttons: [],
      headerClass: "",
      bodyClass: "",
    });
  };

  return (
    <>
      <Modal
        show={showCurrent}
        onHide={() => {
          handleClose();
          resetForm();
        }}
        backdrop="static"
        keyboard={false}
        className="narrative-modal"
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isGotoMasterClicked && isMaster ? (
              currentGotoMasterLabel
            ) : (
              <>
                {currentDiagnosis?.name}{" "}
                {currentOpenedNarrative.age_group_id == 1
                  ? ""
                  : ageGroup?.min_age == 0
                    ? `| Age <${ageGroup?.max_age}`
                    : ageGroup?.min_age == 26
                      ? `| Age >${ageGroup?.min_age}`
                      : `| Age ${ageGroup?.min_age}${
                          ageGroup?.max_age ? ` - ${ageGroup?.max_age}` : "+"
                        }`}
              </>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body id="my-modal">
          <Form>
            <Form.Group className="form-group narrative-type justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <Form.Label name="narrative-type">
                  Narrative type{" "}
                  <LinkWithTooltip
                    tooltip={
                      isMaster
                        ? "Original source — other narratives can link to it."
                        : "Inherits content from a Master. Updates to the Master are applied here automatically."
                    }
                  >
                    <img src={path_image + "info_circle_icon.svg"} alt="Link" />
                  </LinkWithTooltip>
                </Form.Label>
                <div
                  className="switch narrative-switch"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <label className="switch-light">
                    <input
                      type="checkbox"
                      checked={isMaster}
                      onChange={toggle}
                      style={{ margin: 0 }}
                    />
                    <span>
                      <span
                        className={`switch-btn ${isMaster ? "active" : ""}`}
                      >
                        Master <img src={vector} />
                      </span>
                      <span
                        className={`switch-btn ${isMaster ? "" : "active"}`}
                      >
                        Linked <img src={linkImg} />
                      </span>
                    </span>
                    <a className="btn"></a>
                  </label>
                </div>
              </div>
              {!isMaster && (
                <div className="d-flex align-items-center">
                  <Form.Label>
                    Linked to : <span>*</span>
                  </Form.Label>
                  <Select
                    className="split-button-dropup"
                    value={
                      selectedMasterId
                        ? allMaster
                            .map((master) => {
                              const diag = categories.find(
                                (c) => c.id === master.category_id,
                              );
                              const age = ageGroups.find(
                                (a) => a.id === master.age_group_id,
                              );
                              const ageLabel =
                                age?.min_age == null && age?.max_age == null
                                  ? ""
                                  : age?.min_age == 0
                                    ? ` | Age <${age?.max_age}`
                                    : age?.min_age == 26
                                      ? ` | Age >${age?.min_age}`
                                      : ` | Age ${age?.min_age}${
                                          age?.max_age
                                            ? ` - ${age?.max_age}`
                                            : "+"
                                        }`;
                              return {
                                value: master.id,
                                label: `${diag?.name}${ageLabel} (${master.status})`,
                              };
                            })
                            .find((option) => option.value === selectedMasterId)
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleMasterChange({
                        target: {
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    options={
                      allMaster.length > 0
                        ? allMaster.map((master) => {
                            const diag = categories.find(
                              (c) => c.id === master.category_id,
                            );
                            const age = ageGroups.find(
                              (a) => a.id === master.age_group_id,
                            );
                            const ageLabel =
                              age?.min_age == null && age?.max_age == null
                                ? ""
                                : age?.min_age == 0
                                  ? ` | Age <${age?.max_age}`
                                  : age?.min_age == 26
                                    ? ` | Age >${age?.min_age}`
                                    : ` | Age ${age?.min_age}${
                                        age?.max_age
                                          ? ` - ${age?.max_age}`
                                          : "+"
                                      }`;
                            return {
                              value: master.id,
                              label: `${diag?.name}${ageLabel}  (${master.status})`,
                            };
                          })
                        : [
                            {
                              value: "",
                              label: "No master available",
                              isDisabled: true,
                            },
                          ]
                    }
                    placeholder="Select a master"
                  />
                </div>
              )}
            </Form.Group>
            {/* Narrative card */}
            {!isMaster ? (
              selectedMasterId == null ? (
                // Linked mode but no master selected
                <div className="create-change-content">
                  <div className="form_action d-flex justify-content-between align-items-center flex-row">
                    <div className="form_action_links">
                      <h4>Narrative card</h4>
                      <h6>Edits are allowed on the master copy only</h6>
                    </div>
                  </div>
                  <h2 className="no-data">The master copy not selected yet</h2>
                </div>
              ) : (
                // Linked mode with master selected (read-only + Go To Master button)
                <div className="create-change-content">
                  <div className="form_action">
                    <div className="d-flex justify-content-between align-items-start w-100">
                      <div className="form_action_links">
                        <h4>Narrative card</h4>
                        <h6>Edits are allowed on the master copy only</h6>
                      </div>
                      <div className="edit-master-btn">
                        <Button
                          className="btn-bordered btn-voilet"
                          onClick={handleEditMaster}
                        >
                          Go To Master
                        </Button>
                      </div>
                    </div>

                    <Form.Group className="form-group">
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.narrativeTitle}
                        readOnly
                      />
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Label>Content</Form.Label>
                      <ContentEditor
                        value={
                          typeof formData.narrativeContent === "string"
                            ? formData.narrativeContent
                            : ""
                        }
                        handleUpdateElement={(value) =>
                          handleChange("narrativeContent", value || "")
                        }
                        placeholder="Type content here..."
                        isdisabled={!isMaster}
                      />
                    </Form.Group>
                  </div>
                </div>
              )
            ) : (
              // Master mode (fully editable)
              <div className="create-change-content">
                <div className="form_action">
                  <h4>Narrative card</h4>
                  <Form.Group className="form-group">
                    <Form.Label>
                      Title <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Narrative title"
                      value={formData.narrativeTitle}
                      onChange={(e) =>
                        handleChange("narrativeTitle", e.target.value)
                      }
                    />
                  </Form.Group>
                  <Form.Group className="form-group content-add">
                    <Form.Label>
                      Content <span>*</span>
                    </Form.Label>
                    <ContentEditor
                      value={
                        typeof formData.narrativeContent === "string"
                          ? formData.narrativeContent
                          : ""
                      }
                      handleUpdateElement={(value) =>
                        handleChange("narrativeContent", value || "")
                      }
                      placeholder="Type content here..."
                      isdisabled={!isMaster} // <-- match prop name
                    />
                  </Form.Group>
                </div>
              </div>
            )}
            {!isMaster ? (
              selectedMasterId == null ? (
                <div className="create-change-content">
                  <div className="form_action d-flex justify-content-between align-items-center flex-row">
                    <div className="form_action_links">
                      <h4>Octapharma's contribution card</h4>
                      <h6>Edits are allowed on the master copy only</h6>
                    </div>
                  </div>
                  <h2 className="no-data">The master copy not selected yet</h2>
                </div>
              ) : (
                <div className="create-change-content">
                  <div className="form_action">
                    <div className="d-flex justify-content-between align-items-start w-100">
                      <div className="form_action_links">
                        <h4>Octapharma's contribution card</h4>
                        <h6>Edits are allowed on the master copy only</h6>
                      </div>
                    </div>
                    <Form.Group className="form-group">
                      <Form.Label>
                        Title <span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Narrative title"
                        value={formData.contributionTitle}
                        onChange={(e) =>
                          handleChange("contributionTitle", e.target.value)
                        }
                        readOnly={!isMaster}
                      />
                    </Form.Group>
                    <Form.Group className="form-group content-add">
                      <Form.Label>
                        Content <span>*</span>
                      </Form.Label>
                      <ContentEditor
                        value={
                          typeof formData.contributionContent === "string"
                            ? formData.contributionContent
                            : ""
                        }
                        handleUpdateElement={(value) =>
                          handleChange("contributionContent", value || "")
                        }
                        placeholder="Type content here..."
                        isdisabled={!isMaster} // <-- match prop name
                      />
                    </Form.Group>{" "}
                  </div>
                </div>
              )
            ) : (
              <div className="create-change-content">
                <div className="form_action">
                  <h4>Octapharma's contribution card</h4>
                  <Form.Group className="form-group">
                    <Form.Label>
                      Title <span>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Narrative title"
                      value={formData.contributionTitle}
                      onChange={(e) =>
                        handleChange("contributionTitle", e.target.value)
                      }
                      readOnly={!isMaster}
                    />
                  </Form.Group>
                  <Form.Group className="form-group content-add">
                    <Form.Label>
                      Content <span>*</span>
                    </Form.Label>
                    <ContentEditor
                      value={
                        typeof formData.contributionContent === "string"
                          ? formData.contributionContent
                          : ""
                      }
                      handleUpdateElement={(value) =>
                        handleChange("contributionContent", value || "")
                      }
                      placeholder="Type content here..."
                      isdisabled={!isMaster} // <-- match prop name
                    />
                  </Form.Group>{" "}
                </div>
              </div>
            )}
            {/* {selectedMasterId == null && !isMaster ? (
              <div className="create-change-content">
                <div className="form_action d-flex justify-content-between align-items-center flex-row">
                  <div className="form_action_links">
                    <h4>Octapharma's contribution card</h4>
                    <h6>Edits are allowed on the master copy only</h6>
                  </div>
                </div>
                <h2 className="no-data">The master copy not selected yet</h2>
              </div>
            ) : (<div className="create-change-content">
              <div className="form_action">
                <h4>Octapharma's contribution card</h4>
                <Form.Group className="form-group">
                  <Form.Label>Title <span>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Narrative title"
                    value={formData.contributionTitle}
                    onChange={(e) => handleChange("contributionTitle", e.target.value)}
                    readOnly={!isMaster}
                  />
                </Form.Group>
                <Form.Group className="form-group content-add">
                <Form.Label>Content <span>*</span></Form.Label>
                <ContentEditor
                value={typeof formData.contributionContent === "string" ? formData.contributionContent : ""}
                handleUpdateElement={(value) => handleChange("contributionContent", value || "")}
                placeholder="Type content here..."
                isdisabled={!isMaster}   // <-- match prop name
              />
                </Form.Group> </div>
            </div>)} */}
            {selectedMasterId == null && !isMaster ? null : (
              <Form.Group className="form-group tags-group">
                <Form.Label>
                  Topics <span>*</span>
                </Form.Label>
                <div className="input-group d-flex w-100 align-items-center">
                  {/* Show Add Topic button only in Master mode */}

                  <div className="tags_added">
                    {formData.finalTags?.length === 0 && (
                      <div className="no-topics">No topics added yet</div>
                    )}
                    <ul>
                      {formData.finalTags.map((tag, index) => (
                        <li className="list1" key={index}>
                          {tag}
                          {/* Show remove cross only in Master mode */}
                          {isMaster && (
                            <img
                              src={path_image + "filter-close.svg"}
                              alt="remove"
                              onClick={() => removeTag(index)}
                            />
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                  {isMaster && (
                    <div className="input-group-prepend">
                      <Button
                        className="btn-bordered"
                        onClick={() => {
                          setShowCurrent(false);
                          setShowTopics(true);
                        }}
                      >
                        Add Topic +
                      </Button>
                    </div>
                  )}
                </div>
              </Form.Group>
            )}{" "}
            {draftSelected && !isMaster && (
              <div className="surgery-draft-msg">
                <p>
                  This narrative can't be published yet — the master copy is
                  still in draft
                </p>
              </div>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ marginRight: "auto" }}
            variant="secondary"
            onClick={handleClose}
            className="btn-bordered"
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            className="btn-bordered"
            disabled={isAllEmpty}
            // onClick={() =>
            //   openConfirmationPopup("Draft", isMaster ? "master" : "linked")
            // }
            onClick={() => {
              if (
                currentOpenedNarrative?.status === "Missing" ||
                currentOpenedNarrative?.status === "Draft"
              ) {
                setShowCurrent(false);
                handlePopupClose();
                storeNarrativeCardData("Draft");
              } else {
                openConfirmationPopup("Draft", isMaster ? "master" : "linked");
              }
            }}
          >
            Save As Draft
          </Button>

          <Button
            variant="primary"
            disabled={isPublishDisabled || (isMaster ? false : draftSelected)}
            // onClick={() =>
            //   openConfirmationPopup("Live", isMaster ? "master" : "linked")
            // }
            onClick={() => {
              if (
                currentOpenedNarrative?.status === "Missing" ||
                currentOpenedNarrative?.status === "Draft"
              ) {
                setShowCurrent(false);
                handlePopupClose();
                storeNarrativeCardData("Live");
              } else {
                openConfirmationPopup("Live", isMaster ? "master" : "linked");
              }
            }}
          >
            Publish
          </Button>
        </Modal.Footer>
      </Modal>
      {showTopics && (
        <TopicModals
          show={showTopics}
          setShow={setShowTopics}
          showCurrent={showCurrent}
          setShowCurrent={setShowCurrent}
          topics={formData.finalTags}
          setTopics={setFormData}
          allTags={allTags}
          setAllTags={setAllTags}
        />
      )}

      {<PopHandler popArguments={popArguments} />}
    </>
  );
};
